import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icon from "Components/Icon"

export default function DadCBottomNavigation() {
    const [t] = useTranslation()
    const navigate = useNavigate();

    return (
        <div className="bottom-navbar">
            <div className={`bottom-navbar-item ${(window.location.pathname == "/" ? "bottom-navbar-item--active" : "")}`} onClick={() => navigate("/")}>
                <div className="bottom-navbar-item_icon">
                    <Icon name='home-2' />
                </div>
                <span className="bottom-navbar-item_text">{t("HOME")}</span>
            </div>
            <div className={`bottom-navbar-item ${(window.location.pathname.toLocaleLowerCase() == ("/Visits").toLocaleLowerCase() ? "bottom-navbar-item--active" : "")}`} onClick={() => navigate("/Visits")}>
                <div className="bottom-navbar-item_icon relative">
                    <Icon name='directbox-default-2' />
                    <span className="w-[10px] h-[10px] rounded-full bg-warning absolute left-0 top-0"></span>
                </div>
                <span className="bottom-navbar-item_text">{t("VISITS")}</span>
            </div>
            <div className={`bottom-navbar-item ${(window.location.pathname.toLocaleLowerCase() == ("/Account").toLocaleLowerCase() ? "bottom-navbar-item--active" : "")}`} onClick={() => navigate("/Account")}>
                <div className="bottom-navbar-item_icon">
                    <Icon name='profile' />
                </div>
                <span className="bottom-navbar-item_text">{t("ACCOUNT")}</span>
            </div>
        </div>
    );
}